export default __webpack_public_path__ + "static/media/pp-188-ms.1fec4aef.png";